import React from 'react';
import '../../styles/App.scss';
// import NavbarTabs from './NavbarTabs';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
// import ToggleIconNav from './ToggleIconNav';

function NavbarMain({onFontChange, currFont}){
    return(
        <>
            <div className="App-nav">
                {/* <NavbarTabs/> */}
                <DesktopNav/>
                <MobileNav/>
                {/* <ToggleIconNav onFontChange={onFontChange} currFont ={currFont}/> */}
            </div>
        </>
    );
}
export default NavbarMain;